import { render } from "./base-overview-card.vue?vue&type=template&id=57810d2c&ts=true"
import script from "./base-overview-card.vue?vue&type=script&lang=ts"
export * from "./base-overview-card.vue?vue&type=script&lang=ts"

import "./base-overview-card.vue?vue&type=style&index=0&id=57810d2c&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__